import { ContractNew } from '../types';

export const MOCK_CONTRACTS: readonly ContractNew[] = [
  {
    id: '1',
    contractor_id: '1',
    sign_date: '2024-01-15T00:00:00.000Z',
    amount: 150000,
    created_at: new Date('2024-01-15').toISOString(),
    is_deleted: false
  },
  {
    id: '2',
    contractor_id: '2',
    sign_date: '2024-02-01T00:00:00.000Z',
    amount: 75000,
    created_at: new Date('2024-02-01').toISOString(),
    is_deleted: false
  },
  {
    id: '3',
    contractor_id: '3',
    sign_date: '2024-02-20T00:00:00.000Z',
    amount: 200000,
    created_at: new Date('2024-02-20').toISOString(),
    is_deleted: false
  },
  {
    id: '4',
    contractor_id: '4',
    sign_date: '2024-03-01T00:00:00.000Z',
    amount: 95000,
    created_at: new Date('2024-03-01').toISOString(),
    is_deleted: false
  }
] as const;
